import React, { useEffect, useState } from "react";
import { BsInstagram, BsTwitter, BsYoutube } from "react-icons/bs";
import { SiTiktok } from "react-icons/si";
import classes from "./General.module.css";
import CryptoJS from "crypto-js";

const General = () => {
  const initialState = {
    instagramLink: "",
    twitterLink: "",
    youtubeLink: "",
    tiktokLink: "",
    instagramDisplay: false,
    twitterDisplay: false,
    youtubeDisplay: false,
    tiktokDisplay: false,
  };
  const [link, setLink] = useState(initialState);
  const [logo, setLogo] = useState(null);
  const [preview, setPreview] = useState();
  const [selectedImage, setSelectedImage] = useState({
    link: "",
    blob: "",
    details: null,
  });

  const onUploadImage = (e) => {
    let fileToUpload = e.target.files[0];
    const objectUrl = URL.createObjectURL(fileToUpload);
    setPreview(objectUrl);
    let reader = new FileReader();
    reader.onload = (event) => {
      setSelectedImage({
        link: objectUrl,
        blob: event.target.result,
        details: {
          type: fileToUpload.type,
          name: fileToUpload.name,
          size: fileToUpload.size,
        },
      });
    };
    reader.readAsDataURL(fileToUpload);
  };

  const linkHandler = (event) => {
    const { name, value, checked, type } = event.target;
    setLink((preVal) => {
      return {
        ...preVal,
        [name]: type === "checkbox" ? checked : value,
      };
    });
  };

  let user = "";
  let bytes = "";

  const submitHandler = async (e) => {
    e.preventDefault();

    user = localStorage.getItem("user");
    bytes = CryptoJS.AES.decrypt(user, "thisistest");
    const adminId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    link._id = adminId.id;
    try {
      const data = await fetch(
        process.env.REACT_APP_API_URL +
        "update-general-settings",
        {
          method: "POST",
          body: JSON.stringify(link),
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      const response = await data.json();
      if (response) {
      }
    } catch (error) {
      console.log(error);
    }
  };

  const imageSubmitHandler = async (e) => {
    e.preventDefault();
    selectedImage.pathName = 'admin';
    try {
      const data = await fetch(
        process.env.REACT_APP_API_URL +
        "image-upload-blob",
        {
          method: "POST",
          body: JSON.stringify(selectedImage),
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      const response = await data.json();
      if (response.status === true) {
        user = localStorage.getItem("user");
        bytes = CryptoJS.AES.decrypt(user, "thisistest");
        const adminId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        const imageSet = await fetch(process.env.REACT_APP_API_URL +"logo-set", {
          method: "POST",
          body: JSON.stringify({ logo: response.filename, _id: adminId.id }),
          headers: {
            "Content-type": "application/json",
          },
        });
        const result = await imageSet.json();
        if (result) {
          console.log("updated");
        } else {
          console.log("err");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const imgSvgHandler = () => {
    setLogo(null);
    setPreview(undefined);
  };

  useEffect(() => {
    try {
      (async () => {
        const data = await fetch(
          process.env.REACT_APP_API_URL +
          "get-general-settings"
        );
        const response = await data.json();
        setLink(response.setting);
        const logoURL = process.env.REACT_APP_IMAGE_URL + "admin-images/" + response.setting.logo;
        setLogo(logoURL);
      })();
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row page-titles">
          <ol className="breadcrumb">
            <li className="breadcrumb-item active">General Settings</li>
          </ol>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header d-block">
                <h4 className="card-title">Logo</h4>
              </div>
              <form onSubmit={imageSubmitHandler}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      {logo && (
                        <div className={classes.logoImg}>
                          <img src={`${logo}`} alt="Admin" />
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={imgSvgHandler}
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="11"
                              fill="#0D0C22"
                              stroke="white"
                              strokeWidth="2"
                            ></circle>
                            <g clipPath="url(#clip0)">
                              <path
                                d="M15.7766 8.21582L8.86487 15.1275"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M15.7823 15.1347L8.86487 8.21582"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </g>
                            <defs>
                              <clipPath id="clip0">
                                <rect
                                  width="10.3784"
                                  height="10.3784"
                                  fill="white"
                                  transform="translate(7.13513 6.48633)"
                                ></rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      )}
                      {preview && (
                        <div className={classes.logoImg}>
                          <img src={preview} alt="Admin" />
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={imgSvgHandler}
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="11"
                              fill="#0D0C22"
                              stroke="white"
                              strokeWidth="2"
                            ></circle>
                            <g clipPath="url(#clip0)">
                              <path
                                d="M15.7766 8.21582L8.86487 15.1275"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M15.7823 15.1347L8.86487 8.21582"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </g>
                            <defs>
                              <clipPath id="clip0">
                                <rect
                                  width="10.3784"
                                  height="10.3784"
                                  fill="white"
                                  transform="translate(7.13513 6.48633)"
                                ></rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      )}
                      {!preview && !logo && (
                        <input
                          type="file"
                          accept="image/*"
                          // {...register("profile", { required: true })}
                          onChange={(event) => {
                            onUploadImage(event);
                          }}
                        />
                      )}
                    </div>
                    <div className="col-md-12 d-flex justify-content-end">
                      <button className="btn btn-secondary" type="submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header d-block">
                <h4 className="card-title">Social Links</h4>
                <p className="m-0 subtitle">footer links.</p>
              </div>
              <form onSubmit={submitHandler}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <BsInstagram />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Username"
                          name="instagramLink"
                          defaultValue={link.instagramLink}
                          onChange={linkHandler}
                        />
                        <div className="input-group-text">
                          Display &nbsp;
                          <input
                            type="checkbox"
                            name="instagramDisplay"
                            checked={link.instagramDisplay}
                            onChange={linkHandler}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <BsTwitter />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Username"
                          name="twitterLink"
                          defaultValue={link.twitterLink}
                          onChange={linkHandler}
                        />
                        <div className="input-group-text">
                          Display &nbsp;
                          <input
                            type="checkbox"
                            name="twitterDisplay"
                            checked={link.twitterDisplay}
                            onChange={linkHandler}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <BsYoutube />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Username"
                          name="youtubeLink"
                          defaultValue={link.youtubeLink}
                          onChange={linkHandler}
                        />
                        <div className="input-group-text">
                          Display &nbsp;
                          <input
                            type="checkbox"
                            name="youtubeDisplay"
                            checked={link.youtubeDisplay}
                            onChange={linkHandler}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <SiTiktok />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Username"
                          name="tiktokLink"
                          defaultValue={link.tiktokLink}
                          onChange={linkHandler}
                        />
                        <div className="input-group-text">
                          Display &nbsp;
                          <input
                            type="checkbox"
                            name="tiktokDisplay"
                            checked={link.tiktokDisplay}
                            onChange={linkHandler}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 d-flex justify-content-end">
                      <button className="btn btn-secondary" type="submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default General;
